import SaleSearch from '../../views/Sale/components/SaleSearch';

export default [
    {
        path: '/vendas',
        name: 'sale.list',
        component: () => import(/* webpackChunkName: "sale" */ '../../views/Sale/SaleList.vue'),
        meta: {
            pageTitle: 'Vendas',
            searchBar: SaleSearch,
            breadcrumb: [
                { label: 'Vendas' },
            ],
        },
    },
    {
        path: '/vendas/cadastro',
        component: () => import(/* webpackChunkName: "sale" */  '../../views/Sale/SaleEdit.vue'),
        children: [
            {
                path: '',
                name: 'sale.create',
                component: () => import(/* webpackChunkName: "sale" */  '../../views/Sale/SaleEditBuyer.vue')
            },
            {
                path: 'bovinos',
                name: 'sale.create.bovines',
                component: () => import(/* webpackChunkName: "sale" */  '../../views/Sale/SaleEditBovine.vue')
            },
            {
                path: 'valores',
                name: 'sale.create.values',
                component: () => import(/* webpackChunkName: "sale" */  '../../views/Sale/SaleEditValue.vue')
            },
            {
                path: 'revisao',
                name: 'sale.create.review',
                component: () => import(/* webpackChunkName: "sale" */  '../../views/Sale/SaleEditReview.vue')
            },
        ],
        meta: {
            pageTitle: 'Cadastro de Venda',
            breadcrumb: [
                { label: 'Vendas', routeName: 'sale.list' },
                { label: 'Cadastro de Venda' },
            ],
        },
    },
    {
        path: '/vendas/:id',
        name: 'sale.edit',
        component: () => import(/* webpackChunkName: "sale" */  '../../views/Sale/SaleEditReview.vue'),
        meta: {
            pageTitle: 'Edição de Venda',
            breadcrumb: [
                { label: 'Vendas', routeName: 'sale.list' },
                { label: 'Edição de Venda' },
            ],
        },
    },
];
